<script setup lang="ts">
import LuckyRushButtonBgImage from '@/assets/images/periodic/lucky-rush/lucky-rush-button-bg.png'
import TicketImage from '@/assets/images/gifs/ticket.gif'
import { formatDuration } from '@/helpers/date'
import { useGiveaway } from '@/composables/game/giveaway'
import { T } from '@tolgee/vue'
import { computed } from 'vue'

const { countdown, drawn } = useGiveaway()

const isLiveDrawFinished = computed(() => !countdown.value && drawn.value)
</script>

<template>
  <div
    class="flex flex-col items-center justify-center"
  >
    <div class="lucky-rush-button bg-dark-primary relative flex items-center justify-center size-12 rounded-[15px] p-0.5">
      <img
        class="size-full object-cover z-[3]"
        :src="LuckyRushButtonBgImage"
      >
      <img
        class="absolute size-10 object-cover left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[4]"
        :src="TicketImage"
      >
    </div>
    <div class="z-[10] flex flex-col -mt-2 items-center">
      <div class="z-[1] whitespace-nowrap h-[18px] px-1.5 rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] text-tropee-black">
        <T
          key-name="lucky_rush.button"
          default-value="Lucky Rush"
        />
      </div>
      <div
        v-if="!!countdown"
        class="z-[2] -mt-1 whitespace-nowrap h-[18px] px-1.5 rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] tabular-nums"
        :class="countdown < (3600 * 6) ? 'text-red-danger' : 'text-tropee-black'"
      >
        {{ formatDuration(countdown, undefined, countdown > (3600 * 72)) }}
      </div>
    </div>
  </div>
</template>
<style scoped>
.lucky-rush-button::before {
	background: linear-gradient(
		to bottom,
		rgba(255, 255, 255, 0.4) 0%,
		rgba(255, 255, 255, 1) 50%,
		rgba(255, 255, 255, 0.4) 100%
	);
	border-radius: 15px;
	content: "";
	inset: 0;
	-webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
	-webkit-mask-composite: xor;
	mask-composite: exclude;
	padding: 2px; /* this is the border width */
	position: absolute;
	z-index: 10;
	pointer-events: none;
}
</style>
